(function() { window.GUID_c237080f_b1b3_4b59_9e77_2e9b54ca577c = { getGuid: function() { return "c237080f-b1b3-4b59-9e77-2e9b54ca577c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        function RegisterEvent(controlConstructor, eventName, param) {
            registerStaticEvent(controlConstructor, param.selector, eventName, param.callback, param.childSelector, param.extraEventNamespace);
        }
        Controls.RegisterEvent = RegisterEvent;
        function registerStaticEvent(controlConstructor, elementSelector, eventName, callback, selector, extraEventNamespace) {
            if (!elementSelector) {
                return;
            }
            let name = "";
            let $element = null;
            let strNameSpace = "";
            if (CS.Types.IsJquery(elementSelector)) {
                $element = elementSelector;
                name = $element.attr('id');
                //alert('ok ' + name);
            }
            else if (CS.Types.IsPrimitiveControl(elementSelector)) {
                var control = elementSelector;
                $element = control.$Control;
                name = control.ControlId;
                //alert('Prim ' + name);
            }
            else if (CS.Types.IsArrayOf(elementSelector, Controls.PrimitiveControlBase)) {
                $element = GetJQueryObject(elementSelector);
            }
            else if (selector) {
                // So we don't unsubscribe many events with the same elementselector
                name = selector.replace(/[^a-z0-9\-]|^[^a-z]+/g, ""); //This String will be a valid Html id [Start and end with letter & remove all non alphanumeric except the "-"]:  Testit: http://jsfiddle.net/crxu04og/
                $element = $(elementSelector);
            }
            else if (typeof elementSelector === 'string') {
                name = elementSelector.replace(/[^a-z0-9\-]|^[^a-z]+/g, ""); //This String will be a valid Html id [Start and end with letter & remove all non alphanumeric except the "-"]:  Testit: http://jsfiddle.net/crxu04og/
                $element = $(elementSelector);
            }
            else {
                alert(JSON.stringify(elementSelector));
            }
            strNameSpace = name;
            if (extraEventNamespace) {
                strNameSpace += extraEventNamespace;
            }
            let eventHandler = function (e, extraParams) {
                let instance = CS.Controls.GetInstance(controlConstructor, $(this));
                callback.call(instance, instance, extraParams);
            };
            if (selector)
                $element.offon(eventName + "." + strNameSpace, selector, eventHandler);
            else
                $element.offon(eventName + "." + strNameSpace, eventHandler);
        }
        function GetJQueryObject(controls) {
            var array = $.map(controls, function (control) {
                return $.map(control.$Control.get(), function (el) {
                    return el;
                });
            });
            return $(array);
        }
        Controls.GetJQueryObject = GetJQueryObject;
        let pageInstanceIdCursor = 0;
        let instanceIdCursor = 0;
        function GetNewInstanceId() {
            instanceIdCursor += 1;
            return `AutoInstance${pageInstanceIdCursor}-${instanceIdCursor}Id`;
        }
        Controls.GetNewInstanceId = GetNewInstanceId;
        function GetNewUniqueEventNamespace() {
            instanceIdCursor += 1;
            return `AutoName${pageInstanceIdCursor}-${instanceIdCursor}Id`;
        }
        Controls.GetNewUniqueEventNamespace = GetNewUniqueEventNamespace;
        function IncrementInstanceIdPage() {
            instanceIdCursor = 0;
            pageInstanceIdCursor += 1;
        }
        Controls.IncrementInstanceIdPage = IncrementInstanceIdPage;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=control-events.pre.js.map
